import { ProductOffersItemPharmaciesSchema2 } from "src/models/productPharmacies/getProductPharmacies";
import { setInstanceByEnvType } from "src/utils/helpers/requestApi/isServer";

interface ProductMapOffersParams {
  product_slug: string;
  city_slug: string;
  isFutureBooking?: boolean;
  isTodayBooking?: boolean;
  isDayAndNight?: boolean;
}

export interface MapOffersSchema {
  min_price: number;
  longitude: number;
  latitude: number;
  distance: number;
  color_code: number;
  items: ProductOffersItemPharmaciesSchema2[];
}

export const getMapOffers = (params: ProductMapOffersParams) =>
  setInstanceByEnvType().get<MapOffersSchema[]>(
    "/catalog/product_page/map_offers",
    {
      params,
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
    }
  );
